import React from 'react'
// ##
import ViewDistributor from '../../modules/Distributor/components/ViewDistributor'

export default function DistributorPage() {
  return <ViewDistributor />
}
